import { SITE_MAP } from 'globalConstants';
import { isEmpty, isEqual, map } from 'lodash';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const Toolbar = () => {
  const pathname = usePathname();
  const navigations = [
    {
      name: 'Văn phòng công chứng',
      pathname: `/${SITE_MAP.NOTARIZATION.INDEX}`,
    },
    {
      name: 'Văn phòng đăng ký đất đai',
      pathname: `/${SITE_MAP.OFFICE_REGISTRATION.INDEX}`,
    },
    {
      name: 'Ngân hàng',
      pathname: `/${SITE_MAP.BANK_LOAN.INDEX}`,
    },
  ];

  return (
    <div id='toolbar' className='flex items-center space-x-[28px]'>
      {isEmpty(navigations) || (
        <nav>
          <ul className='flex items-center space-x-[32px]'>
            {map(navigations, (navigation, navigationIndex) => (
              <li key={navigationIndex} className='group/navigation relative'>
                <Link href={navigation.pathname} passHref className='flex items-center text-text'>
                  <span
                    className={`${
                      isEqual(pathname, navigation.pathname) && 'text-primary'
                    } text-center text-[16px] font-[600] leading-[20px]`}
                  >
                    {navigation.name}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Toolbar;
